const themePalette = {
    green: {
        primary: '#2C7E84',
        primaryHover: '#24666B',
        primaryClicked: '#1F565A',
        primaryLightHover: '#F4F9F9',
        primaryLightSelected: '#DFECED',
        primaryHighlights: '#97D6DA',
    },
    blue: {
        primary: '#28416B',
        primaryHover: '#203556',
        primaryClicked: '#1B2D49',
        primaryLightHover: '#F4F5F8',
        primaryLightSelected: '#DFE3E9',
        primaryHighlights: '#617EAF',
    },
    purple: {
        primary: '#9418C7',
        primaryHover: '#7712A1',
        primaryClicked: '#6A0F90',
        primaryLightHover: '#FAF3FC',
        primaryLightSelected: '#EFDCF7',
        primaryHighlights: '#CEA7DF',
    },
} as const;

const system = {
    error: {
        main: '#D32F2F', // error message & info icons
        bg: '#FDEDED', // Used as BG for error message
        text: '#5F2120', // Used when we have error BG
    },
    warn: {
        main: '#EF6C00', // warn message & warn icons
        bg: '#FFF4E5', // Used as BG for warn message & info icons
        text: '#663C00', // Used when we have warn BG
    },
    info: {
        main: '#0288D1', // Info message & info icons
        bg: '#E5F6FD', // Used as BG for info message & info icons
        text: '#014361', // Used when we have info BG
    },
    success: {
        main: '#2E7D32', // success message & success icons
        bg: '#EDF7ED', // Used as BG for warn message & info icons
        text: '#1E4620', // Used when we have success BG
    },
} as const;

const common = {
    white: '#FFF', // bg
    black: '#202020', // Used for all primary texts, as a hover for inputs
    grey1: '#636466', // all secondary texts
    grey2: '#CFCFCF', // text fields, borders, states: default, filled, disabled
    grey3: '#E3E3E3', // dividers
    grey4: '#F8F8F8', // bg
} as const;

export const colors = {
    ...common,
    system,
    themes: {
        green: themePalette.green,
        blue: themePalette.blue,
        purple: themePalette.purple,
    },
} as const;
